import MonthView from './views/MonthView'
import moment from 'moment-mini'
import { Carousel, CarouselItem } from '../carousel'
import CalendarHeader from './CalendarHeader'

export default {
  name: 'KCalendar',
  props: {
    // 可切换的模式数组：day, week, month, year
    modes: {
      type: Array,
      // ['day', 'week', 'month', 'year']
      default() {
        return ['day', 'week', 'month', 'year']
      },
    },
    // 初始模式
    mode: {
      type: String,
      default: 'month',
    },
    // 日期值
    value: {
      type: moment,
      // null
      default() {
        return null
      },
    },
  },
  data() {
    return {
      innerValue: null,
    }
  },
  computed: {
    prevValue() {
      if (this.innerValue) {
        return this.innerValue.clone().subtract(1, this.mode)
      }
    },
    nextValue() {
      if (this.innerValue) {
        return this.innerValue.clone().add(1, this.mode)
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.innerValue = this.value ? moment(this.value) : moment()
      },
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {},
  render() {
    return (
      <div class="km-calendar">
        <CalendarHeader value={this.innerValue} />
        <Carousel
          autoHeight={true}
          autoplay={false}
        >
          <CarouselItem>
            <MonthView
              value={this.prevValue}
            >
            </MonthView>
          </CarouselItem>
          <CarouselItem>

            <MonthView
              value={this.innerValue}
            >
              {this.$slots.default}
            </MonthView>
          </CarouselItem>
          <CarouselItem>

            <MonthView
              value={this.nextValue}
            >
            </MonthView>
          </CarouselItem>
        </Carousel>
      </div>
    )
  },
}
